"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeafNode = void 0;
const tree_node_1 = require("./tree.node");
class LeafNode extends tree_node_1.TreeNode {
    isLeaf = true;
    _token; // original token from parsed formula
    _abstractText; // text based on language definition (in english). only defined after translation
    _translation; //value to be used on translate return
    constructor(originalNode, parent) {
        super(originalNode, parent);
        this._token = originalNode.getText();
        this._translation = this._token;
    }
    init(_allNodes) {
        return;
    }
    get token() {
        return this._token;
    }
    set token(token) {
        this._token = token;
    }
    get text() {
        return this._translation;
    }
    set text(text) {
        this._translation = text;
    }
    get abstractText() {
        return this._abstractText;
    }
    set abstractText(text) {
        this._abstractText = text;
    }
    get translation() {
        return this._translation;
    }
    set translation(translation) {
        this._translation = translation;
    }
    get parent() {
        return this._parent;
    }
    set parent(parent) {
        this._parent = parent;
    }
    get originalNode() {
        return this._originalNode;
    }
    get children() {
        return []; // leaf nodes cannot have children
    }
    set children(children) {
        return;
    }
    addChildren(_) {
        return;
    }
    toString() {
        if (this.text !== undefined)
            return this.text;
    }
    translate(_opts) {
        return this._translation;
    }
    hasChildren() {
        return false;
    }
}
exports.LeafNode = LeafNode;
